// extracted by mini-css-extract-plugin
export var acitonButtons = "_ct-0";
export var additionalIcon = "_ct-f";
export var block = "_ct-1";
export var blockContent = "_ct-7";
export var blockDescription = "_ct-8";
export var blockIcon = "_ct-9";
export var blockTitle = "_ct-6";
export var border = "_ct-a";
export var center = "_ct-l";
export var edge = "_ct-b";
export var edgeLabel = "_ct-c";
export var edgePath = "_ct-d";
export var error = "_ct-e";
export var flowchart = "_ct-g";
export var flowchartContent = "_ct-h";
export var highlighted = "_ct-3";
export var hover = "_ct-4";
export var icon = "_ct-i";
export var left = "_ct-m";
export var navButton = "_ct-j";
export var navButtons = "_ct-k";
export var right = "_ct-n";
export var selected = "_ct-2";
export var small = "_ct-5";